import { useCallback } from 'react';
import { useIsPaidPortal } from '../inventory/useProductInventory';
import { useIsInAppAuth, useIsPartnerProgramEligible } from '../user/useUserInfo';
import { useLocalStorage } from '../utilities/useLocalStorage';
const BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';
export const usePartnerProgramBanner = () => {
  const isInAppAuth = useIsInAppAuth();
  const isPartnerProgramEligible = useIsPartnerProgramEligible();
  const {
    isPaidPortal,
    loading: isInventoryLoading
  } = useIsPaidPortal();
  const [isBannerDismissed, setIsBannerDismissed] = useLocalStorage(BANNER_DISMISSED_KEY);
  const shouldShowPartnerProgramBanner = isInAppAuth && isPartnerProgramEligible && !isPaidPortal && !isInventoryLoading && !isBannerDismissed;
  const dismissBanner = useCallback(() => {
    setIsBannerDismissed('true');
  }, [setIsBannerDismissed]);
  return {
    shouldShowPartnerProgramBanner,
    dismissBanner
  };
};